import { Box, Typography, Container, Grid } from "@mui/material";
import NotificationCard from "../notifications/NotificationCard";
import NotificationBell from "../notifications/NotificationBell";
import ScriptLoader from "../account/ScriptLoader";
import { useNav } from "../../context/NavProvider";
import { useClient } from "../../context/ClientProvider";
import ActionButton from "../account/ActionButton";
import { useParty } from "../../context/PartyProvider";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
/**
 * Notifications page component
 * @returns
 */
function NotificationsPage() {
    const navigate = useNavigate();
    const { useGetConfig, setDisableProfile } = useClient();
    const { clientConfig } = useGetConfig();
    const { useGetParty } = useParty();
    const { party } = useGetParty();
    const { setShowFooter, setHideHeaderNavBars, setShowCallMeIcon, setHideSignOut } = useNav();

    setShowFooter(false);

    useEffect(() => {
        setHideHeaderNavBars(true)
        if (!clientConfig?.layout?.notifications?.showMyAccountButton) {
            setDisableProfile({ required: true })
            setHideSignOut(true)
        }
        if (!clientConfig?.layout?.notifications?.showCallMe) {
            setShowCallMeIcon(false)
        }
    }, [])

    const handleRemindLaterClick = () => {
        localStorage.setItem('remindMeLaterClicked', 'true');
        setHideHeaderNavBars(false);
        setDisableProfile({ required: false });
        setHideSignOut(false)
        setShowCallMeIcon(true);
        navigate("/");
    };

    const handleViewMyAccountClick = () => {
        localStorage.setItem('viewMyAccountClicked', 'true');
        setHideHeaderNavBars(false);
        setDisableProfile({ required: false });
        setHideSignOut(false)
        setShowCallMeIcon(true);
        navigate("/");
    };

    const handleStartClick = () => {
        localStorage.setItem('startAccessibilityClicked', 'true');
        setHideHeaderNavBars(false);
        setDisableProfile({ required: false });
        setHideSignOut(false)
        setShowCallMeIcon(true);
        navigate("/accessibility");
    };

    return (
        <>
            <ScriptLoader /> {/* Load scripts based on consent */}
            <Container sx={{ mt: 4, mb: 7, paddingBottom: "350px" }}>
                <Typography fontSize={34} fontWeight={"bold"} sx={{ mb: -4 }}>
                    Hi {party?.customerName.first},
                </Typography>
                <Box sx={{ mb: 3 }}>
                    <Grid container alignItems="center" spacing={2}>
                        <Grid item>
                            <NotificationBell notificationCount={1} />
                        </Grid>
                        <Grid item>
                            <Typography fontSize={28} fontWeight={"bold"} sx={{ color: "#797979", mt: 3 }}>
                                Notifications
                            </Typography>
                        </Grid>
                    </Grid>
                </Box>
                {/* Notification Cards */}
                <Grid container direction="row" spacing={5} marginBottom={{ lg: 5, xs: 0, md: 5, sm: 3, xl: 5 }} justifyContent="center">
                    <Grid item spacing={5} style={{
                        minWidth: "50%"
                    }}>
                        <Grid container direction="column" spacing={5}>
                            {clientConfig?.layout?.notifications?.cards?.one?.showCard && <Grid item spacing={5} size={{ xs: 6, md: 8 }} style={{
                                minWidth: "50%"
                            }}>
                                {/* Card Number 1 */}

                                <NotificationCard
                                    id={clientConfig?.layout?.notifications?.cards?.one.id}
                                    title={clientConfig?.layout?.notifications?.cards?.one.title}
                                    textOne={clientConfig?.layout?.notifications?.cards?.one.textOne}
                                    textTwo={clientConfig?.layout?.notifications?.cards?.one.textTwo}
                                    startTarget={clientConfig?.layout?.notifications?.cards?.one.startTarget}
                                    onRemindLaterClick={handleRemindLaterClick}
                                    handleStartClick={handleStartClick}
                                >
                                </NotificationCard>
                            </Grid>}
                            {clientConfig?.layout?.notifications?.cards?.three?.showCard && <Grid item spacing={5} style={{
                                minWidth: "50%"
                            }}>
                                {/* Card Number 3 */}
                                <NotificationCard
                                    id={clientConfig?.layout?.notifications?.cards?.three.id}
                                    title={clientConfig?.layout?.notifications?.cards?.three.title}
                                    textOne={clientConfig?.layout?.notifications?.cards?.three.textOne}
                                    textTwo={clientConfig?.layout?.notifications?.cards?.three.textTwo}
                                    startTarget={clientConfig?.layout?.notifications?.cards?.three.startTarget}
                                    onRemindLaterClick={handleRemindLaterClick}
                                >
                                </NotificationCard>
                            </Grid>}
                        </Grid>
                    </Grid>
                    <Grid item spacing={5} style={{
                        minWidth: "50%"
                    }}>
                        <Grid container direction="column" spacing={5}>
                            {clientConfig?.layout?.notifications?.cards?.two?.showCard && <Grid item spacing={5} style={{
                                minWidth: "50%"
                            }}>
                                {/* Card Number 2 */}

                                <NotificationCard
                                    id={clientConfig?.layout?.notifications?.cards?.two.id}
                                    title={clientConfig?.layout?.notifications?.cards?.two.title}
                                    textOne={clientConfig?.layout?.notifications?.cards?.two.textOne}
                                    textTwo={clientConfig?.layout?.notifications?.cards?.two.textTwo}
                                    startTarget={clientConfig?.layout?.notifications?.cards?.two.startTarget}
                                    onRemindLaterClick={handleRemindLaterClick}
                                >
                                </NotificationCard>
                            </Grid>}
                            {clientConfig?.layout?.notifications?.cards?.four?.showCard && <Grid item spacing={5} style={{
                                minWidth: "50%"
                            }}>
                                {/* Card Number 4 */}

                                <NotificationCard
                                    id={clientConfig?.layout?.notifications?.cards?.four.id}
                                    title={clientConfig?.layout?.notifications?.cards?.four.title}
                                    textOne={clientConfig?.layout?.notifications?.cards?.four.textOne}
                                    textTwo={clientConfig?.layout?.notifications?.cards?.four.textTwo}
                                    startTarget={clientConfig?.layout?.notifications?.cards?.four.startTarget}
                                    onRemindLaterClick={handleRemindLaterClick}
                                >
                                </NotificationCard>
                            </Grid>}
                        </Grid>
                    </Grid>
                </Grid>
                <ActionButton
                    id='start-btn'
                    variant='contained'
                    buttonColor='primary.dark'
                    buttonTextColor='primary.contrastText'
                    borderColor='transparent'
                    hoverColor='primary.contrastText'
                    hoverBorderColor='primary.dark'
                    hoverTextColor='primary.dark'
                    buttonTitle='View my account'
                    target='/'
                    onClick={handleViewMyAccountClick}
                />
            </Container>
            {setShowFooter(true)}
        </>
    );
}

export default NotificationsPage;
